export const styles = {
    tableMenuDialog: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
};
